import React from 'react';

const LinkText = ({
  path, text
}) => {
  return (
    <a
      className='Table__a'
      href={`/${gon.currentProvider}/${path}`}
    >
      { text }
    </a>
  )
}

export default LinkText;
